import { render, staticRenderFns, recyclableRender, components } from "./certificationCofirm.vue?vue&type=template&id=7aa70306&"
var renderjs
import script from "./certificationCofirm.vue?vue&type=script&lang=js&"
export * from "./certificationCofirm.vue?vue&type=script&lang=js&"
import style0 from "./certificationCofirm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../soft/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null,
  false,
  components,
  renderjs
)

component.options.__file = "pages/merchant/applyMerchant/certificationCofirm.vue"
export default component.exports